// src/Utils/permissionsCore.js

export const normalizeRole = (role) => String(role || "").toLowerCase().trim();

export const PRIVILEGED_ROLES = ["hallitus", "isännöitsijä", "admin"];

/**
 * Palauttaa käyttäjän roolit valitussa yhtiössä.
 * @param {object} user
 * @param {string} companyId
 * @returns {Array}
 */
export function getRolesForCompany(user, companyId) {
  const roles = Array.isArray(user?.userRoles) ? user.userRoles : [];
  if (!companyId) return [];
  return roles.filter((r) => r?.companyId === companyId);
}

/**
 * Tarkistaa löytyykö käyttäjältä jokin annetuista rooleista valitussa yhtiössä.
 * Case-insensitive.
 * @param {object} user
 * @param {string} companyId
 * @param {string[]} allowedRoles
 * @returns {boolean}
 */
export function hasAnyRole(user, companyId, allowedRoles = []) {
  const allowed = new Set((allowedRoles || []).map(normalizeRole));
  return getRolesForCompany(user, companyId).some((r) =>
    allowed.has(normalizeRole(r?.role))
  );
}

/**
 * Hallitus / isännöitsijä / admin valitussa yhtiössä.
 * @param {object} user
 * @param {string} companyId
 * @returns {boolean}
 */
export function isPrivileged(user, companyId) {
  return hasAnyRole(user, companyId, PRIVILEGED_ROLES);
}
